import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ApplicationState = {
  stepIndex: number;
  answers: Record<string, string>;
  setAnswer: (key: string, value: string) => void;
  setStep: (stepIndex: number) => void;
  reset: () => void;
};

export const useApplicationStore = create<ApplicationState>()(persist(
  (set) => ({
    stepIndex: -1,
    answers: {},
    setAnswer: (key, value) => set((state) => ({ answers: { ...state.answers, [key]: value } })),
    setStep: (stepIndex) => set({ stepIndex }),
    reset: () => set({ stepIndex: -1, answers: {} }),
  }),
  { name: 'sugarloaf-application-draft', storage: createJSONStorage(() => localStorage) },
));
